<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Notificación</h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    @if (notificacion(); as n) {
      <h2 class="notificacion-titulo">{{ n.x_titulo }}</h2>

      <div class="text-detail-item mb-3">
        {{ n.d_fecha | date: 'dd/MM/yyyy - HH:mm' }}hs
      </div>

      @if (getImgUrl(n.x_comunicacion_img); as img) {
        <img [src]="img" alt="Imagen de la notificación" class="notificacion-img mb-3" />
      }

      <p class="notificacion-descripcion">{{ n.x_descripcion }}</p>
    }

    @if (error()) {
      <div class="alert alert-danger mt-4" role="alert">
        <small>{{ error() }}</small>
      </div>
    }
  </div>
</div>
